<script>
export default {
  data() {
    return {}
  },

  props: {
    idappcode: String,
    idcategory: Number,
    state: String,
    buttonUrl: String,
    buttonLabel: String,
    backbuttonUrl: String,
    backbuttonLabel: String,
    selectedcategories: Array,
    isnewcategory: Boolean,

  },

  computed: {
    newselectedcategories: function () {
      return [this.idcategory].concat(this.selectedcategories)
    }
  },

  methods: {
    go: function () {
      if (this.isnewcategory) {
        this.doUploadSelectedCategory()
      } else {
        this.buttonurlgo()
      }
    },


    doUploadSelectedCategory: function () {

      jQuery.ajax({
        url: themosis.ajaxurl,
        dataType: 'json',
        type: 'POST',
        data: {
          action: 'application-putselectedcategories',
          security: themosis.nonce,
          idappcode: this.idappcode,
          selectedcategories: this.newselectedcategories,
          categorieslastmodified: Date.now()
        }
      }).done(function (r) {

        if ((typeof (r.error) !== 'undefined') && (r.error !== 'none')) {
          alert('Error on selected categories upload: ' + r.error);
        } else {
          this.buttonurlgo()
        }

      }.bind(this)).fail(function (j, error) {

        alert('Communication error: ' + error)

      })

    },

    buttonurlgo: function () {
      window.location = this.buttonUrl
    },


  }
}

</script>

<template>
  <div>
    <button @click="go" class="btn btn-primary rounded-pill text-white mr-2" v-text="buttonLabel" v-if="buttonLabel !== ''"></button>
    <a :href="backbuttonUrl" class="btn btn-primary rounded-pill ml-2" v-text="backbuttonLabel" v-if="backbuttonLabel !== ''"></a>
  </div>
</template>
